import TableLayout, {
  TableNullState,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';
import { formatBillingDate, formatDollar } from 'dashboard/lib/utils/formatters';
import { Commitment } from 'dashboard/models/invoice';

interface CommitmentsTableProps {
  commitments: Commitment[];
}

const CommitmentsTable = ({ commitments }: CommitmentsTableProps) => {
  const currentCommitments = commitments.map((commitment: Commitment) => {
    return (
      <TableTR
        key={commitment.id}
        id={`commitments-table__row--${commitment.id}`}
        data-test={`commitments--${commitment.id}`}
      >
        <TableTD>
          {commitment['commitment-period-start-at'] && commitment['commitment-period-start-at']
            ? `${formatBillingDate(commitment['commitment-period-start-at'])} - ${formatBillingDate(
                commitment['commitment-period-end-at'],
              )}`
            : '-'}
        </TableTD>
        <TableTD>
          {commitment['used-amount-cents-on-pending-invoices']
            ? formatDollar(commitment['used-amount-cents-on-pending-invoices'] / 100)
            : '-'}
        </TableTD>
        <TableTD>
          {commitment['total-used-amount-cents-including-pending-invoices']
            ? formatDollar(commitment['total-used-amount-cents-including-pending-invoices'] / 100)
            : '-'}
        </TableTD>
        <TableTD>
          {commitment['remaining-amount-cents-including-pending-invoices']
            ? formatDollar(commitment['remaining-amount-cents-including-pending-invoices'] / 100)
            : '-'}
        </TableTD>
        <TableTD>
          {commitment['initial-amount-cents']
            ? formatDollar(commitment['initial-amount-cents'] / 100)
            : '-'}
        </TableTD>
      </TableTR>
    );
  });

  return (
    <>
      <TableLayout
        dataTest='commitments-table'
        showHeader={true}
        isEmpty={!commitments || commitments.length === 0}
        nullState={
          <TableNullState>
            <div>
              It looks like you have no currently active commitments as part of your subscription.
            </div>
          </TableNullState>
        }
        headerTR={
          <>
            <TableTH data-test='commitments-table__period'>Commitment Period</TableTH>
            <TableTH data-test='commitments-table__used-up-within-current-period'>
              Used Amount In Current Billing Period
            </TableTH>
            <TableTH data-test='commitments-table__used-including-current-period'>
              Total Used Amount
            </TableTH>
            <TableTH data-test='commitments-table__used-including-current-period'>
              Total Remaining Amount
            </TableTH>
            <TableTH data-test='commitments-table__initial-amount'>Total Commitment Amount</TableTH>
          </>
        }
      >
        {currentCommitments}
      </TableLayout>
    </>
  );
};

export default CommitmentsTable;
